import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/src/app";
import "./globals.css";

const root = document.getElementById("root");

if (root) {
	createRoot(root).render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}
